import { Component, EventEmitter, Output, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { PollService } from '../../../bdo/services/poll.service';

@Component({
    selector: 'bdo-poll-frame',
    templateUrl: './poll-frame.component.html',
    styleUrl: './poll-frame.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PollFrameComponent implements OnDestroy {
  constructor(public readonly pollService: PollService) {
  }

  onClose() {
    this.pollService.closePoll();
  }

  ngOnDestroy(): void {
    // leaving a page that hosted a poll closes it for the rest of the session, whether or not the next page has one too
    if (this.pollService.currentPoll()) {
      this.pollService.closePoll();
    }
  }
}
